<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="justify-content-start mb-5">
          <b-col cols="4" lg="2" xl="1">
            <back-button :returnUrl="returnUrl"></back-button>
          </b-col>
        </b-row>
        <spinner v-if="activateSpinner"></spinner>
        <email-group-form :mode="mode" :readonly="!isEditable" v-model="config" v-else></email-group-form>
        <b-row class="justify-content-end">
          <b-col cols="4" lg="2" xl="1" v-if="isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="switchMode('details')">
              <span>{{ $t('common.cncl') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="switchMode('edit')">
              <i class="fa-light fa-pencil"></i>
              <span>{{ $t('administration.edit') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="deleteEmailGroup">
              <i class="fa-light fa-trash"></i>
              <span>{{ $t('rights.delete') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="editEmailGroup">
              <i class="fa-light fa-save"></i>
              <span>{{$t('common.sve')}}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="mode === 'add'">
            <b-button variant="primary"
              @click="addEmailGroup">
              <i class="fa-light fa-save"></i>
              <span>{{$t('common.sve')}}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import EmailGroupForm from '@/pages/email/EmailGroupForm.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: "EmailGroupDetails",
  components: {
    'back-button': backButton,
    'email-group-form': EmailGroupForm,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    mode: {
      type: String,
      default: "add"
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    },
    pageTitle() {
      switch (this.mode) {
        case 'edit':
          return this.$t('Webheader.email_group_edit')
        case 'details':
          return this.$t('Webheader.email_group_details')
        case 'add':
        default:
          return this.$t('Webheader.email_group_add')
      }
    }
  },
  data() {
    return {
      activateSpinner: false,
      email: '',
      returnUrl: '',
      currentEmailGroup: {},
      savedConfig: [],
      config: {},
      originalConfig: {},
      formType: 'add'
    }
  },
  created() {
    this.activateSpinner = true
    this.formType = this.mode

    this.returnUrl = '/email/emailGroup/-1'

    if(this.id !== '-1' && (this.mode === "details" ||"edit")) {
      this.getEmailGroup()
    } else {
      this.activateSpinner = false
    }
  },
  methods: {
    addEmailGroup () {
      let that = this
      if (this.formHasError()) {
        return
      }
      let params = {
        GroupName: this.config.GroupName,
        Name: this.config.emailAddList.map(emailAdd => emailAdd.Name.trim()).join(', '),
        Email: this.config.emailAddList.map(emailAdd => emailAdd.Email.trim()).join(', '),
        id: this.id
      }

      this.$engine.email.emailGroup.create(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.email.email_group_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/email/emailGroup/-1'})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.email.email_group_addition_error'))
      })
    },
    deleteEmailGroup () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.email.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdEmailGroup: that.id
              }
              that.$engine.email.emailGroup.delete(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('common.email.email_group_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                loadPage(that, {url: '/email/emailGroup/-1'})
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.email.email_group_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editEmailGroup () {
      let that = this
      let params = {
        GroupName: this.config.GroupName,
        IdEmailGroup: this.id
      }
      this.$engine.email.emailGroup.edit(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.email.email_group_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, { url: '/email/emailGroup/-1' })
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.email.email_group_edition_error'))
      })
    },
    fillFields () {
      this.config = this.currentEmailGroup
      this.originalConfig = this.currentEmailGroup
      this.activateSpinner = false
    },
    formHasError () {
      if (this.config.GroupName === undefined || this.config.length === 0) {
        this.okMessageBox(this.$t('common.email.email_group_name_missing'))
        return true
      }
      if (!this.config.emailAddList || this.config.emailAddList.length === 0) {
        this.okMessageBox(this.$t('common.email.email_address_list_missing'))
        return true
      }

      for (let i = 0; i < this.config.emailAddList.length; i++) {
        const emailAdd = this.config.emailAddList[i]

        if (!emailAdd.Name || emailAdd.Name.trim().length === 0) {
          this.okMessageBox(
            this.$t('common.email.email_address_name_missing')
          )
          return true
        }

        if (!emailAdd.Email || emailAdd.Email.trim().length === 0) {
          this.okMessageBox(
            this.$t('common.email.email_address_missing')
          )
          return true
        }
      }
      return false
    },
    getEmailGroup () {
      let that = this
      this.$engine.email.emailGroup.fetch({id: this.id})
      .then(resp => {
        let emailGroupList = {}

        emailGroupList = resp.data.EmailGroup
        that.updateEmailGroup(emailGroupList)
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchMode (mode) {
      if (mode === 'details' && this.formType === 'edit') {
        this.config = this.originalConfig
      }
      this.formType = mode
    },
    updateEmailGroup (emailGroupList) {
      const selectedEmail = emailGroupList.find(email => email.IdEmailGroup === this.id)
      this.currentEmailGroup = selectedEmail
      this.fillFields()
    }
  }
}
</script>
